import CustomTabContainer from "../../../../components/CustomTabContainer";
import {SEARCH_MODEL} from "../../../../components/table/Model/TableModel";
import CustomTab from "../../../../components/CustomTab";
import AddEmployee from "./AddEmployee";
import AssignedEmployee from "./AssignedEmployee";
import React from "react";
import {TrashOutlineIcon} from "../../../../components/buttons/IconButtons";
import ButtonAction from "../../../../components/buttons/ButtonAction";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 */

const TabPanel = ({
                      setBodyForExport,
                      searchElement,
                      setSearchElement,
                      setSearch,
                      setSimpleSearch,
                      modified,
                      setModified,
                      authentication,

                      id,
                      setDeviceList,
                      tabsConfig,
                      addKey,
                      assignedKey,
                      useTabApp,
                      subView,

                      selectForDelete,
                      setSelectForDelete,

                      triggerDelete,
                      setTriggerDelete,
                      disabled
                  }) => {
    const {
        t,
        results,
        setResults,
        isAllChecked,
        setIsAllChecked,
        subViewChild,
        setSubViewChild
    } = useTabApp()

    // Read-only mode only shows what is already assigned
    const activeTab = disabled ? tabsConfig[assignedKey].key : subViewChild;
    const tabs = tabsConfig.getTabsByTABS(id)
        .filter((item) => !disabled || item.key === tabsConfig[assignedKey].key);

    return (
        <div className={"shift-detail-lists border-full-shades-200 col-12 border-radius-8px px-0"}>
            <CustomTabContainer
                activeTab={activeTab}
                setActiveTab={(e) => {
                    setSearchElement("");
                    setResults(SEARCH_MODEL.clearResults());
                    setSubViewChild(e);
                }}
                className="border-0 px-3 d-flex justify-content-between"
                paddingClass=''
                buttonAction={
                    !disabled && subViewChild === tabsConfig[assignedKey].key &&
                        <ButtonAction
                            id={"btn_fa_delete"}
                            name='delete'
                            className={`btn-icon-delete h-100`}
                            Icon={TrashOutlineIcon}
                            disabled={selectForDelete.length <= 0}
                            onClick={() => setTriggerDelete(true)}
                        />
                }
            >
                {tabs.map((item) => (
                    <CustomTab
                        key={item.key}
                        id={item.key}
                        title={t(item.translation)}
                        icon={item.icon}
                        selected={activeTab === item.key}
                        onClick={() => setSubViewChild(item.key)}
                    />
                ))}
            </CustomTabContainer>

            <div className="border-bottom-shades-300 mb-3" />

            {!disabled && activeTab === tabsConfig[addKey].key &&
                <AddEmployee
                    setBodyForExport={setBodyForExport}
                    results={results}
                    setResults={setResults}
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    setSearch={setSearch}
                    setSimpleSearch={setSimpleSearch}
                    modified={modified}
                    setModified={setModified}
                    selected={selectForDelete}
                    setSelected={setSelectForDelete}
                    subView={subView}
                    authentication={authentication}
                    setDeviceListCustomAccessOrDepartment={setDeviceList}
                    id={id}
                />
            }
            {activeTab === tabsConfig[assignedKey].key &&
                <AssignedEmployee
                    setBodyForExport={setBodyForExport}
                    results={results}
                    setResults={setResults}
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    setSearch={setSearch}
                    setSimpleSearch={setSimpleSearch}
                    modified={modified}
                    setModified={setModified}
                    selected={selectForDelete}
                    setSelected={setSelectForDelete}
                    isAllChecked={isAllChecked}
                    setIsAllChecked={setIsAllChecked}
                    subView={subView}
                    authentication={authentication}
                    id={id}
                    disabled={disabled}
                    triggerDelete={triggerDelete}
                    setTriggerDelete={setTriggerDelete}
                />
            }
        </div>
    )
}

export default TabPanel
